/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  IconChevronLeft,
  IconMapPin,
  IconPackage,
  IconUser,
  IconX,
  IconExternalLink,
  IconClock,
  IconTruck,
  IconBuildingWarehouse,
  IconPhone,
  IconMail,
  IconCornerDownRight,
  IconBuilding,
  IconHash,
  IconId,
} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import {
  useFetchOrderDetailsData,
  useFetchOrderDetailsStatusHistoryData,
  useFetchOrdersData,
  useOrderDeleteMutation,
  useOrderReverseMutation,
  useOrderStatusRevertMutation,
  useOrderSyncMutation,
  useOrderUpdateMutation,
} from "../../apis/orderApis";
import formatDate, { formatTime } from "../../utilities/helper";
import EditOrderModal from "./_components/EditOrderModal";
import {
  use3PLListData,
  useCreateForwardOrderMutation,
} from "../../apis/3plApis";
import { OrderFormData } from "../../types/types";
import { useForm } from "react-hook-form";
import useDebounce from "../../utilities/useDebounce";
import toast from "react-hot-toast";
import ReverseOrderModal from "./_components/ReverseOrderModal";
import AddOrdersModal from "./_components/AddOrdersModals";
import SmsModal from "./_components/SmsModal";
import Forword3PlModal from "./_components/Forword3PlModal";
import DeleteModal from "./_components/DeleteModal";
import MessageModal from "../../components/MessageModal";
import LabelPrintModal from "./_components/LabelPrintModal";
import { useSelector } from "react-redux";
import BulkUploadModals from "./_components/BulkUploadModals";
import NewCommonModal from "../../components/common/NewCommonModal";
import LoadingScreen from "../../components/common/LoadingScreen";
import ReverseItemModal from "./_components/ReverseItemModal";
import { useAddLocationCoverageMutation } from "../../apis/warehouseApi";
import OrderTimeLine from "./_components/OrderTimeLine";
import { usePermission } from "../../hooks/usePermissionTabs";
import { T, useLanguage } from "../../context/LanguageContext";

const Mini = ({ label, value, className }: any) => (
  <div
    className={`p-4 border border-[#D2D2D2] rounded-md shadow-sm flex items-center space-x-3 ${className} ${value ? "bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]" : "bg-transparent"}`}
  >
    <p className="text-xs text-gray-500 whitespace-nowrap "><T>{label}</T> :</p>
    <p className="font-medium text-sm break-all">{value || ""}</p>
  </div>
);

const DetailBox = ({
  label,
  value,
  isHighlight,
  badge,
}: {
  label: string;
  value: any;
  isHighlight?: boolean;
  badge?: boolean;
}) => (
  <div className="bg-slate-50/60 border border-slate-200/80 rounded-xl p-4 flex justify-between items-center hover:border-slate-350/60 transition duration-150">
    <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">
      <T>{label}</T>
    </p>
    {badge && value ? (
      <div className="mt-1.5 flex">
        <span className="text-xs font-semibold px-2 py-0.5 rounded bg-[#FBD037]/15 text-amber-700 border border-[#FBD037]/30 uppercase">
          <T>{value}</T>
        </span>
      </div>
    ) : (
      <p
        className={`text-sm font-semibold mt-1 break-all ${isHighlight ? "text-amber-600 font-bold" : "text-slate-700"
          }`}
      >
        {typeof value === "string" ? <T>{value}</T> : value || "—"}
      </p>
    )}
  </div>
);

const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => (
  <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
    <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
      <Icon size={16} className="text-[#212121]" stroke={1.5} />
    </div>
    <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
      <T>{title}</T>
    </p>
  </div>
);

export default function ViewOrderDetails() {
  const { t, language } = useLanguage();
  const { allowed: canUpdateOrder } = usePermission("orders", "update");
  const { allowed: canDeleteOrder } = usePermission("orders", "delete");

  const [showModal, setShowModal] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [showReverseModal, setShowReverseModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const toggleFilter = () => setShowFilter(!showFilter);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isReverseOrderWiseOpen, setIsReverseOrderWiseOpen] = useState(false);
  const [isRevertOrder, setIsRevertOrder] = useState(false);
  const [isSmsOpen, setIsSmsOpen] = useState(false);
  const [isForword3PlOpen, setIsForword3PlOpen] = useState(false);
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [order, setOrder] = useState<any>();
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const openForword3PlModal = (order: any) => {
    setOrder(order);
    setIsForword3PlOpen(true);
    setIsEditOpen(false);
    setIsSmsOpen(false);
    setIsDeleteOpen(false);
    setShowLabelModal(false);
  };
  const closeForword3PlModal = () => setIsForword3PlOpen(false);
  const openSmsModal = () => {
    setIsSmsOpen(true);
    setIsEditOpen(false);
    setIsForword3PlOpen(false);
    setIsDeleteOpen(false);
    setShowLabelModal(false);
  };
  const closeSmsModal = () => setIsSmsOpen(false);
  const openEditModal = (data: any) => {
    setOrder(data);
    setIsEditOpen(true);
    setIsForword3PlOpen(false);
    setIsSmsOpen(false);
    setIsDeleteOpen(false);
    setShowLabelModal(false);
  };
  const [orderItemId, setOrderItemId] = useState<any>(null);
  const closeEditModal = () => setIsEditOpen(false);
  const { mutate: reverseOrderMutate, isPending: isReverseOrderPending } =
    useOrderReverseMutation();
  const { mutate: revertOrderMutate } = useOrderStatusRevertMutation(
    order?.id ?? "",
  );
  const { mutate: deleteMutate, isPending: isDeletePending } =
    useOrderDeleteMutation(order?.id ?? "");
  const { mutate: syncMutate } = useOrderSyncMutation();
  const { mutate: updateMutate, isPending: isUpdatePending } =
    useOrderUpdateMutation(order?.id ?? "");
  const { mutate: forwardMutate, isPending: isCreateForward3PLPending } =
    useCreateForwardOrderMutation(order?.id ?? "");
  const { data: shippingPartners } = use3PLListData();
  const [activeTab, setActiveTab] = useState("All");
  const tabs = ["All", "Deleted", "Reverse", "Cancelled"];
  const profile = useSelector((state: any) => state.auth.profile);

  const [openGeneratePickup, setOpenGeneratePickup] = useState<boolean>(false);
  const openGeneratePickupToggleModal = () => {
    setOpenGeneratePickup(!openGeneratePickup);
  };

  const [reverseInventory, setReverseInventory] = useState<boolean>(false);
  const openSetReverseInventoryModal = () => {
    setReverseInventory(!reverseInventory);
  };

  const {
    data: orders,
    isPending: listPending,
    refetch,
  } = useFetchOrdersData(
    pageNo,
    limit,
    searchFor,
    activeTab === "Reverse",
    // pending,
    activeTab === "Cancelled",
    activeTab === "Deleted",
  );

  const openDeleteModal = (data: any) => {
    setOrder(data);
    setIsDeleteOpen(true);
    setIsEditOpen(false);
    setIsForword3PlOpen(false);
    setIsSmsOpen(false);
    setShowLabelModal(false);
  };

  const debouncedSearchFor = useDebounce(searchFor, 550);

  useEffect(() => {
    refetch();
  }, [debouncedSearchFor, pageNo, limit, activeTab]);

  const {
    register,
    setValue,
    clearErrors,
    formState: { errors },
    watch,
    control,
    handleSubmit,
  } = useForm<OrderFormData>();

  const {
    register: forwardRegister,
    setValue: setForwardValue,
    clearErrors: forwardClearErrors,
    formState: { errors: forwardErrors },
    watch: forwardWatch,
    handleSubmit: handleForwardSubmit,
  } = useForm<any>();

  const {
    register: deleteRegister,
    setValue: deleteSetValue,
    clearErrors: deleteClearErrors,
    formState: { errors: deleteErrors },
    watch: deleteWatch,
    reset: deleteReset,
    handleSubmit: deleteHandleSubmit,
  } = useForm<any>();
  const closeDeleteModal = () => setIsDeleteOpen(false);
  const openReverseOrderWiseModal = () => setIsReverseOrderWiseOpen(true);
  const closeReverseOrderWiseModal = () => setIsReverseOrderWiseOpen(false);
  const closeRevertOrder = () => setIsRevertOrder(false);

  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [isWebhookLoading, setIsWebhookLoading] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (value: string) => {
    setSelectedOption(value);
    setOpen(false);

    if (value === "NewOrder") setShowModal(true);
    else if (value === "BulkOrder") setShowBulkModal(true);
    else if (value === "ReverseOrder") setShowReverseModal(true);
  };

  const options = [
    { label: "New Order", value: "NewOrder" },
    { label: "Bulk Upload", value: "BulkOrder" },
    { label: "Reverse Order", value: "ReverseOrder" },
  ];
  const navigate = useNavigate();

  const deleteOrder = (data: any) => {
    deleteMutate(data, {
      onSuccess: (data) => {
        deleteReset();
        setIsDeleteOpen(false);
        refetch();
        toast.success("Order deleted successfully");
      },
      onError: (error: any) => {
        console.error(error, "error");
        toast.error(error.message || "Failed to delete order");
      },
    });
  };

  const handleUpdateOrder = (data: any) => {
    updateMutate(data, {
      onSuccess: (data) => {
        setIsEditOpen(false);
        refetch();
        refreshAllDetails();
        toast.success("Order updated successfully");
      },
      onError: (error: any) => {
        console.error(error, "error");
        toast.error(error.message || "Failed to update order");
      },
    });
  };

  const handleLabelPrint = (data: any) => {
    setOrder(data);
    setShowLabelModal(true);
    setIsEditOpen(false);
    setIsForword3PlOpen(false);
    setIsSmsOpen(false);
    setIsDeleteOpen(false);
  };

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };
  const handleReverseOrder = () => {
    reverseOrderMutate(
      { orderId: [orderItemId] },
      {
        onSuccess: (data) => {
          setIsRevertOrder(false);
          refreshAllDetails();
          toast.success("Reverse Order created");
        },
        onError: (error) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      },
    );
    setIsReverseOrderWiseOpen(false);
  };
  const handleRevertOrder = () => {
    revertOrderMutate(undefined, {
      onSuccess: (data) => {
        refetch();
        setIsRevertOrder(false);
        refreshAllDetails();
      },
      onError: (error) => {
        console.log(error, "error");
        toast.error(`${error}`);
      },
    });
  };

  const handleForwardOrder = (formData: any) => {
    const selected3pl = shippingPartners?.find(
      (p: any) => p.id === formData?.["3plCompany"],
    );

    const companyName: string = selected3pl?.companyName?.toLowerCase() ?? "";

    const allowedStatuses = ["RECEIVE_IN_WAREHOUSE", "SHELVE", "IN_TRANSIT"];
    if (!allowedStatuses.includes(order?.status)) {
      toast.error(
        `Only Receive in warehouse, Shelve, and In transit orders can be forwarded.`,
      );
      return;
    }

    setIsWebhookLoading(true);

    const payload: any = {
      "3plCompany": formData?.["3plCompany"],
      noOfPieces: formData?.noOfPieces || 1,
    };

    if (companyName === "naqel express" || companyName === "Naqel Express") {
      payload.productType = "DLV";
      payload.dutyHandling = "DDP";
    }

    forwardMutate(payload, {
      onSuccess: (res: any) => {
        if (res?.success === false) {
          toast.error(res?.message || "Failed to forward order");
          setIsWebhookLoading(false);
          return;
        }

        if (companyName === "naqel express") {
          toast.success("Order forwarding to Naqel in progress...");
        } else if (companyName === "aramex") {
          toast.success("Order forwarding to Aramex in progress...");
        } else if (companyName.includes("smsa")) {
          toast.success("Order forwarding to SMSA in progress...");
        } else {
          toast.success("Order forwarding in progress...");
        }

        closeForword3PlModal();

        setTimeout(() => {
          refreshAllDetails();
          toast.success("Order updated successfully");
          setIsWebhookLoading(false);
        }, 3000);
      },

      onError: (error: any) => {
        toast.error(error?.message || "Something went wrong");
        setIsWebhookLoading(false);
      },

      onSettled: () => { },
    });
  };

  const getStatusTextClass = (status: string) => {
    const normalized = status?.toLowerCase();

    switch (normalized) {
      case "draft": // neutral / gray
        return "text-gray-700";
      case "new_order": // info → blue
        return "text-blue-700";
      case "processing": // progress → indigo
        return "text-indigo-700";
      case "ready_for_pickup": // waiting → amber/yellow
        return "text-amber-700";
      case "dispatched": // moving → teal/greenish
        return "text-teal-700";
      case "in_transit": // traveling → sky
        return "text-sky-700";
      case "out_for_delivery": // active → orange
        return "text-orange-700";
      case "delivered": // success → green
        return "text-green-700";
      case "undelivered": // warning → amber
        return "text-amber-700";
      case "returned": // secondary issue → purple
        return "text-purple-700";
      case "cancelled": // error → red
        return "text-red-700";
      case "failed": // danger → rose
        return "text-rose-700";
      case "lost": // dark/neutral → zinc
        return "text-zinc-700";
      case "deleted": // destructive → dark red
        return "text-red-800";
      default: // fallback neutral
        return "text-gray-700";
    }
  };

  const { awb } = useParams();

  interface TooltipProps {
    label: string;
    children: React.ReactNode;
  }

  const Tooltip: React.FC<TooltipProps> = ({ label, children }) => {
    return (
      <div className="relative group inline-block">
        {children}
        <div className="absolute left-1/2 -translate-x-1/2 mt-2 hidden group-hover:block">
          {/* Arrow tip */}
          <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 rotate-45 bg-black"></div>
          {/* Tooltip box */}
          <div className="whitespace-nowrap rounded-md bg-black px-2 py-1 text-xs text-white shadow-lg">
            {label}
          </div>
        </div>
      </div>
    );
  };

  const { data, refetch: fetchOrderDetails } = useFetchOrderDetailsData(
    awb ?? "",
  );
  const { data: statusHistories, refetch: fetchStatusHistories } =
    useFetchOrderDetailsStatusHistoryData(awb ?? "");

  const refreshAllDetails = () => {
    fetchOrderDetails();
    fetchStatusHistories();
  };

  const formatStatus = (status: string) => {
    return status
      ?.toLowerCase()
      ?.split("_")
      ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      ?.join(" ");
  };

  const statusHistory = useSelector(
    (state: any) => state.orders.statusHistory?.[data?.id],
  );

  const hasVariantData = data?.olineItems?.some(
    (item: any) => item?.optionName && item?.optionValue,
  );

  const shouldShowClientId = data?.subStatus !== "reverseOrder";

  const displayClientId = shouldShowClientId ? (data?.clientId ?? "") : "";
  const displayCompanyName = shouldShowClientId ? data?.clientName || "" : "";
  const { mutate: coverageMutate, isPending: isAddLocationCoveragePending } =
    useAddLocationCoverageMutation();

  const handleAddInCoverage = (
    coverageName: any,
    coverageType: string,
    statusId: string | number, // 👈 accept both
  ) => {
    const payload: any = {
      locationName: coverageName,
      warehouseId: data?.warehouseId,
      countryId: data?.receiverCountry,
      coverageType: coverageType,
      statusId: String(statusId), // 👈 always send string to backend
      orderId: data?.id,
    };

    coverageMutate(payload, {
      onSuccess: () => {
        fetchOrderDetails();
        toast.success("Coverage updated successfully!");
      },
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.error?.message ||
          error?.response?.data?.message ||
          error?.message ||
          (typeof error === "string" ? error : null) ||
          "Failed to Update OutSource.";

        toast.error(errorMessage);
      },
    });
  };

  const isOutlet = data?.platform === "OUTLET";

  const isDataReady = data && String(data?.awbNumber) === String(awb);
  const steps = isDataReady ? statusHistories || statusHistory || [] : [];

  const currentStep = steps.length - 1;

  const smartEmail = (email?: string) => {
    if (!email) return "";

    const [name, domain] = email.split("@");
    if (!domain) return email;

    if (name.length <= 5) return email;

    return `${name.slice(0, 4)}...@${domain}`;
  };

  const [activeDetailsTab, setActiveDetailsTab] = useState<"specs" | "items">(
    "specs",
  );

  const itemsCardRef = useRef<HTMLDivElement>(null);
  const [itemsCardHeight, setItemsCardHeight] = useState<number>(400);

  useEffect(() => {
    if (itemsCardRef.current) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          setItemsCardHeight(entry.target.clientHeight);
        }
      });
      resizeObserver.observe(itemsCardRef.current);
      return () => resizeObserver.disconnect();
    }
  }, [data, activeDetailsTab, isEditOpen]);

  const [hoveredLog, setHoveredLog] = useState<any>(null);
  const [tooltipCoords, setTooltipCoords] = useState<{
    top: number;
    left: number;
  } | null>(null);

  useEffect(() => {
    const handleScrollOrResize = () => {
      setHoveredLog(null);
    };
    window.addEventListener("scroll", handleScrollOrResize, { passive: true });
    window.addEventListener("resize", handleScrollOrResize);
    return () => {
      window.removeEventListener("scroll", handleScrollOrResize);
      window.removeEventListener("resize", handleScrollOrResize);
    };
  }, []);

  const isNewOrder = data?.status?.toUpperCase() === "NEW_ORDER";

  const clientType = profile?.clientType;
  const hasItems = data?.olineItems && data.olineItems.length > 0;

  // Logic: Show items if filled
  const showItems = !!hasItems;

  useEffect(() => {
    if (showItems && isNewOrder) {
      setActiveDetailsTab("items");
    } else {
      setActiveDetailsTab("specs");
    }
  }, [isNewOrder, showItems]);

  const orderStatus = data?.status?.toUpperCase() || "";
  const isShipped =
    [
      "DISPATCHED",
      "IN_TRANSIT",
      "OUT_FOR_DELIVERY",
      "DELIVERED",
      "FORWARD_TO_3PL",
      "DEPARTED",
      "PICKED_UP",
    ].includes(orderStatus) || !!data?.shippingAwbNumber;

  // ─── Dynamic Timeline Helpers ───────────────────────────────────────────────

  // Map DB status codes to clean human-readable labels
  const formatStatusName = (status: string): string => {
    const map: Record<string, string> = {
      DRAFT: "Draft",
      NEW_ORDER: "New Order",
      ORDER_CREATED: "Order Created",
      PROCESSING: "Processing",
      READY_FOR_PICKUP: "Ready for Pickup",
      PICKUP_GENERATED: "Pickup Generated",
      PICKUP_COLLECTED: "Pickup Collected",
      RECEIVE_INBOUND: "Receive Inbound",
      RECEIVE_IN_WAREHOUSE: "Received in Warehouse",
      SHELVE: "Shelving",
      SHELVED: "Shelved",
      IN_WAREHOUSE: "In Warehouse",
      ARRIVED_AT_WAREHOUSE: "Arrived at Warehouse",
      DISPATCHED: "Dispatched",
      DISPATCHED_TO_3PL: "Dispatched to 3PL",
      FORWARD_TO_3PL: "Forwarded to 3PL",
      IN_TRANSIT: "In Transit",
      OUT_FOR_DELIVERY: "Out for Delivery",
      DEPARTED: "Departed",
      PICKED_UP: "Picked Up",
      DELIVERED: "Delivered",
      NOT_DELIVERED: "Not Delivered",
      RETURNED: "Returned",
      RETURN_TO_SHIPPER: "Return to Shipper",
      REVERSE_NEW: "Reverse Order",
      REVERSE_ORDER: "Reverse Order",
      CANCELLED: "Cancelled",
      FAILED: "Failed",
      LOST: "Lost",
      DAMAGE: "Damaged",
      PENDING: "Pending",
      PENDING_STOCK: "Pending Stock",
      PICKLIST_GENERATED: "Picklist Generated",
      PICKED: "Picked",
      PACKED: "Packed",
      REVERTED: "Reverted",
      DELETED: "Deleted",
    };
    return (
      map[status?.toUpperCase()] ||
      status?.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) ||
      status
    );
  };

  // Terminal statuses – once here, no future "Delivered" milestone is appended
  const TERMINAL_STATUSES = [
    "DELIVERED",
    "CANCELLED",
    "FAILED",
    "RETURNED",
    "LOST",
    "DELETED",
    "DAMAGE",
    "RETURN_TO_SHIPPER",
    "NOT_DELIVERED",
  ];

  const isTerminal = TERMINAL_STATUSES.includes(orderStatus);

  // Build dynamic milestones from the actual status-history log entries
  const buildDynamicMilestones = () => {
    // Fallback when no history exists yet
    if (!steps || steps.length === 0) {
      const fallback = [
        {
          title: formatStatusName(data?.status || "New Order"),
          subtitle: "",
          date: data?.createdAt || null,
          logEntry: null,
          isFuture: false,
        },
      ];
      if (!isTerminal) {
        fallback.push({
          title: "Delivered",
          subtitle: "Awaiting hand-off",
          date: null,
          logEntry: null,
          isFuture: true,
        });
      }
      return fallback;
    }

    // De-duplicate consecutive identical statuses; keep first occurrence of each
    const seen = new Set<string>();
    const unique = steps.filter((h: any) => {
      const key = h.status?.toUpperCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });

    const milestones = unique.map((h: any) => ({
      title: formatStatusName(h.status),
      subtitle: h.details || h.comment || "",
      date: h.createdAt || null,
      logEntry: h,
      isFuture: false,
    }));

    // Append a pending "Delivered" milestone if the order is not terminal
    if (!isTerminal) {
      const lastStatus = unique[unique.length - 1]?.status?.toUpperCase();
      if (lastStatus !== "DELIVERED") {
        milestones.push({
          title: "Delivered",
          subtitle: "Awaiting hand-off",
          date: null,
          logEntry: null,
          isFuture: true,
        });
      }
    }

    return milestones;
  };

  const dynamicMilestones = buildDynamicMilestones();
  // currentActiveStep: index of the last non-future milestone
  const currentActiveStep = dynamicMilestones.reduce(
    (acc: number, m: any, idx: number) => (!m.isFuture ? idx : acc),
    0,
  );

  return (
    <>
      <div className="px-6 space-y-6">
        {/* Main Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          {/* Left Column */}
          <div ref={itemsCardRef} className="lg:col-span-8 space-y-2">
            <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
              {/* Combined Waybill Info & Action Buttons Card (Glassmorphism design) */}
              <div className=" flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
                {/* Left side: Back Button + AWB Details */}
                <div className="flex items-center gap-4">
                  <button
                    onClick={() => navigate(-1)}
                    className="p-2 border border-slate-200 rounded-full text-slate-600 bg-white/90 hover:bg-slate-100 transition shadow-sm shrink-0"
                  >
                    <IconChevronLeft strokeWidth={2.2} size={18} />
                  </button>

                  <div className="">
                    <h2 className="text-2xl font-extrabold text-slate-800 tracking-wide">
                      {awb}
                    </h2>
                  </div>
                </div>
                <div className="flex items-center gap-2.5">
                  <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
                  <span className="text-[13px] font-bold px-2.5 py-0.5 rounded-full bg-emerald-500/10 text-emerald-700 border border-emerald-500/20 uppercase tracking-wide">
                    <T>{data?.status ? formatStatus(data.status) : "ACTIVE"}</T>
                  </span>
                </div>
              </div>


            </div>
            {/* Card 1: Shipment Timeline & Status */}{" "}
            <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70  transition-all duration-300 overflow-visible">
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
              {/* ── Card Header ── */}
              <div className="flex justify-between items-center px-6 pt-6 pb-0">
                <div className="flex items-center gap-2">
                  <IconClock className="text-slate-400 w-5 h-5" />
                  <h3 className="text-base font-semibold text-[#212121]">
                    <T>Timeline</T>
                  </h3>
                </div>
              </div>

              {/* ── Horizontal Dynamic History Timeline ── */}
              <div
                className="w-full overflow-x-auto"
                style={{ overflowY: "visible" }}
                onScroll={() => setHoveredLog(null)}
              >
                <div
                  className="relative flex items-start gap-0 px-6 pb-4"
                  style={{
                    paddingTop: "24px" /* space above circles */,
                    minWidth: `${dynamicMilestones.length * 130}px`,
                    overflow: "visible",
                  }}
                >
                  {dynamicMilestones.map((milestone: any, idx: number) => {
                    const isCompleted = idx < currentActiveStep;
                    const isCurrent = idx === currentActiveStep;
                    const isFuture = !!milestone.isFuture;
                    const logEntry = milestone.logEntry;
                    const displayDate = milestone.date;

                    return (
                      <div
                        key={idx}
                        className="flex flex-col items-center z-10 relative cursor-pointer group flex-1 min-w-[120px]"
                        style={{ overflow: "visible" }}
                      >
                        {/* Connector line */}
                        {idx !== dynamicMilestones.length - 1 && (
                          <div
                            className={`absolute top-5 w-full h-[3px] z-0 ${language === "ar" ? "right-1/2" : "left-1/2"
                              } ${idx < currentActiveStep
                                ? "bg-emerald-500"
                                : "bg-slate-200"
                              }`}
                          />
                        )}

                        {/* Circle wrapper */}
                        <div
                          className="relative cursor-pointer"
                          style={{ zIndex: 30, overflow: "visible" }}
                          onMouseEnter={(e) => {
                            if (logEntry) {
                              const rect =
                                e.currentTarget.getBoundingClientRect();
                              setTooltipCoords({
                                top: rect.top,
                                left: rect.left + rect.width / 2,
                              });
                              setHoveredLog(logEntry);
                            }
                          }}
                          onMouseLeave={() => {
                            setHoveredLog(null);
                          }}
                        >
                          {/* Circle */}
                          <div
                            className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm border-2 transition-all duration-300 ${isCompleted
                              ? "bg-emerald-500 border-emerald-500 text-white"
                              : isCurrent
                                ? "bg-[#FBD037] border-[#FBD037] text-slate-900 shadow-[0_0_15px_rgba(251,208,55,0.25)]"
                                : "bg-white border-slate-200 text-slate-400"
                              }`}
                          >
                            {isCompleted ? (
                              <svg
                                className="w-5 h-5 text-white"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={3}
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M5 13l4 4L19 7"
                                />
                              </svg>
                            ) : (
                              <span>{idx + 1}</span>
                            )}
                          </div>
                        </div>

                        {/* Labels */}
                        <div className="text-center mt-3 space-y-1 px-1">
                          <p
                            className={`text-xs font-semibold truncate max-w-[130px] ${isCurrent
                              ? "text-amber-700"
                              : isCompleted
                                ? "text-slate-800"
                                : "text-slate-400"
                              }`}
                          >
                            <T>{milestone.title}</T>
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            {/* Card 2: Shipment Details & Item List */}
            <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70  transition-all duration-300 space-y-3">
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
              {/* ── Card Header with Tab Switcher ── */}
              <div className="flex justify-between items-center px-6 py-4 border-b border-slate-100">
                <div className="flex items-center gap-2">
                  <IconPackage className="text-slate-400 w-5 h-5" />
                  <h3 className="text-base font-semibold text-[#212121]">
                    {activeDetailsTab === "specs"
                      ? <T>Shipment Details</T>
                      : <T>Items Details</T>}
                  </h3>
                </div>

                {/* Tab Pills */}
                {showItems && (
                  <div className="flex bg-slate-100/80 p-0.5 rounded-full border border-slate-200 shrink-0">
                    <button
                      onClick={() => setActiveDetailsTab("specs")}
                      className={`py-1 px-3.5 rounded-full text-xs font-semibold transition ${activeDetailsTab === "specs"
                        ? "bg-white text-slate-800 shadow-sm border border-slate-200/40"
                        : "text-slate-500 hover:text-slate-700"
                        }`}
                    >
                      <T>Shipment</T>
                    </button>
                    <button
                      onClick={() => setActiveDetailsTab("items")}
                      className={`py-1 px-3.5 rounded-full text-xs font-semibold transition ${activeDetailsTab === "items"
                        ? "bg-white text-slate-800 shadow-sm border border-slate-200/40"
                        : "text-slate-500 hover:text-slate-700"
                        }`}
                    >
                      <T>Items</T>
                    </button>
                  </div>
                )}
              </div>

              {/* ── Tab Content (Specs or Items) ── */}
              <div className="px-6 pb-4">
                {activeDetailsTab === "specs" ? (
                  <div className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <DetailBox
                        label="Entry Date"
                        value={formatDate(data?.createdAt)}
                      />
                      <DetailBox
                        label="Close Date"
                        value={
                          data?.closedDate ? formatDate(data.closedDate) : "—"
                        }
                      />
                      <DetailBox
                        label="Reference Number"
                        value={data?.referenceNumber}
                        isHighlight={true}
                      />
                      <DetailBox
                        label="Warehouse Location"
                        value={data?.warehouseName}
                      />
                      <DetailBox
                        label="Shelf / Shelf No."
                        value={
                          data?.shelfLocation
                            ? `${data.shelfLocation} - ${data.shelfNo || "—"}`
                            : data?.shelfNo || "—"
                        }
                      />
                      <DetailBox
                        label="Product Category"
                        value={data?.shipmentType || "PARCEL"}
                        badge={true}
                      />
                      <DetailBox
                        label="Payment Mode"
                        value={`${data?.paymentType ? t(data.paymentType) : "—"} - ${data?.codAmount || "0.00"} ${t("SAR")}`}
                      />
                      <DetailBox
                        label="Delivery Route Code"
                        value={data?.routeCode}
                      />
                      <DetailBox
                        label="Delivery Attempts"
                        value={
                          data?.totalDeliveryAttempt !== undefined
                            ? String(data.totalDeliveryAttempt)
                            : "0"
                        }
                      />
                      <DetailBox
                        label="Weight"
                        value={
                          data?.totalWeight
                            ? `${data.totalWeight} ${t("KG")}`
                            : `0.00 ${t("KG")}`
                        }
                      />
                      <DetailBox
                        label="Pieces"
                        value={
                          data?.noOfPieces
                            ? `${data.noOfPieces} ${t("item")}`
                            : `${data?.olineItems?.length || 0} ${t("item")}`
                        }
                      />
                      <DetailBox
                        label="Service"
                        value={data?.serviceType || "Standard"}
                        isHighlight={true}
                      />
                    </div>
                  </div>
                ) : (
                  /* Items Tab */
                  data?.olineItems?.length > 0 && (
                    <div className="overflow-auto max-h-[400px] border border-slate-200/80 rounded-xl">
                      <table className="w-full min-w-[600px] text-sm">
                        <thead className="bg-slate-50 text-slate-500 font-semibold uppercase text-[10px] tracking-wider sticky top-0 border-b border-slate-200">
                          <tr>
                            <th className="p-2 border-r border-dashed text-left font-bold">
                              <T>Item</T>
                            </th>
                            <th className="p-2 border-r border-dashed text-center font-bold">
                              <T>SKU</T>
                            </th>
                            <th className="p-2 border-r border-dashed text-center font-bold">
                              <T>Qty</T>
                            </th>
                            <th className="p-2 border-r border-dashed text-center font-bold">
                              <T>Weight</T>
                            </th>
                            <th className="p-2 border-r text-center font-bold">
                              <T>Price</T>
                            </th>
                            {hasVariantData && (
                              <th className="p-2 text-center font-bold border-r">
                                <T>Variant</T>
                              </th>
                            )}
                            <th className="p-2 text-center font-bold">
                              <T>Description</T>
                            </th>
                          </tr>
                        </thead>
                        <tbody className=" bg-white border-b">
                          {data.olineItems.map((item: any, i: number) => (
                            <tr
                              key={i}
                              className="hover:bg-slate-50/50 transition duration-150"
                            >
                              <td className="p-2 border-r border-b border-dashed  text-xs text-slate-500">
                                {item.itemName}
                              </td>
                              <td className="p-2 border-r border-b border-dashed text-xs  text-center text-slate-500">
                                {item.sku || "—"}
                              </td>
                              <td className="p-2 border-r border-b border-dashed text-center text-slate-700">
                                {item.quantity}
                              </td>
                              <td className="p-2 border-r border-b border-dashed text-center text-xs text-slate-500">
                                {item.weight ? `${item.weight} Kg` : "—"}
                              </td>
                              <td className="p-2 border-r border-b border-dashed text-center font-semibold text-amber-700">
                                {item.price || "—"}
                              </td>
                              {hasVariantData && (
                                <td className="p-2 border-r border-b border-dashed text-center text-xs text-slate-500">
                                  {item.optionValue || "—"}
                                </td>
                              )}
                              <td className="p-2 border-b border-dashe text-center text-xs text-slate-500">
                                {item.description || "—"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="lg:col-span-4 lg:sticky lg:top-6 self-start space-y-2">
            {isEditOpen ? (
              <EditOrderModal
                open={isEditOpen}
                onClose={closeEditModal}
                order={order}
                register={register}
                errors={errors}
                setValue={setValue}
                watch={watch}
                clearErrors={clearErrors}
                handleSubmit={handleSubmit(handleUpdateOrder)}
                isPending={isUpdatePending}
                inPlace={true}
                height={itemsCardHeight}
              />
            ) : showLabelModal ? (
              <LabelPrintModal
                open={showLabelModal}
                onClose={() => setShowLabelModal(false)}
                order={order}
                inPlace={true}
              />
            ) : isForword3PlOpen ? (
              <Forword3PlModal
                open={isForword3PlOpen}
                onClose={closeForword3PlModal}
                register={forwardRegister}
                errors={forwardErrors}
                setValue={setForwardValue}
                watch={forwardWatch}
                data={shippingPartners}
                clearErrors={forwardClearErrors}
                isPending={isWebhookLoading || isCreateForward3PLPending}
                handleSubmit={handleForwardSubmit((formData) =>
                  handleForwardOrder(formData),
                )}
                inPlace={true}
              />
            ) : isSmsOpen ? (
              <SmsModal
                open={isSmsOpen}
                onClose={closeSmsModal}
                inPlace={true}
              />
            ) : isDeleteOpen ? (
              <DeleteModal
                open={isDeleteOpen}
                onClose={closeDeleteModal}
                deleteOrder={deleteHandleSubmit(deleteOrder)}
                isDeletePending={isDeletePending}
                register={deleteRegister}
                clearErrors={deleteClearErrors}
                watch={deleteWatch}
                setValue={deleteSetValue}
                errors={deleteErrors}
                inPlace={true}
              />
            ) : (
              <>
                <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
                  <div className="flex items-center justify-end gap-2 flex-wrap">
                    <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
                    {data?.status === "DELIVERED" ? (
                      // <Tooltip label="Reverse Order">
                      canUpdateOrder && (
                        <button
                          onClick={() => {
                            setOrderItemId(data?.id);
                            openReverseOrderWiseModal();
                          }}
                          className="flex items-center gap-1 p-1.5 text-sm rounded-full border border-slate-200 bg-white hover:bg-slate-50 hover:text-slate-800 transition shadow-sm"
                        >
                          <img
                            src="/img/dashboard-icons/reverse-item.svg"
                            className="size-5"
                          />
                        </button>
                      )
                    ) : (
                      // </Tooltip>
                      <>
                        {data?.status !== "DELETED" && (
                          <>
                            {/* <Tooltip label="Edit Order"> */}
                            {canUpdateOrder && (
                              <button
                                onClick={() => openEditModal(data)}
                                className="flex items-center gap-1 p-1.5 text-sm rounded-full border border-slate-200 bg-white hover:bg-slate-50 hover:text-slate-800 transition shadow-sm"
                              >
                                <img
                                  src="/img/dashboard-icons/edit.svg"
                                  className="size-5"
                                />
                              </button>
                            )}
                            {/* </Tooltip> */}
                            {/* <Tooltip label="Print Order"> */}
                            <button
                              onClick={() => handleLabelPrint(data)}
                              className="flex items-center gap-1 p-1.5 text-sm rounded-full border border-slate-200 bg-white hover:bg-slate-50 hover:text-slate-800 transition shadow-sm"
                            >
                              <img
                                src="/img/dashboard-icons/print.svg"
                                className="size-5"
                              />
                            </button>
                            {/* </Tooltip> */}

                            {/* <Tooltip label="Forward 3PL"> */}
                            {canUpdateOrder && (
                              <button
                                onClick={() => openForword3PlModal(data)}
                                className="flex items-center gap-1 p-1.5 text-sm rounded-full border border-slate-200 bg-white hover:bg-slate-50 hover:text-slate-800 transition shadow-sm"
                              >
                                <img
                                  src="/img/dashboard-icons/forward-3pl.svg"
                                  className="size-5"
                                />
                              </button>
                            )}
                            {/* </Tooltip> */}
                            {/* <Tooltip label="Send SMS"> */}
                            {canUpdateOrder && (
                              <button
                                onClick={openSmsModal}
                                className="flex items-center gap-1 p-1.5 text-sm rounded-full border border-slate-200 bg-white hover:bg-slate-50 hover:text-slate-800 transition shadow-sm"
                              >
                                <img
                                  src="/img/dashboard-icons/sms.svg"
                                  className="size-5"
                                />
                              </button>
                            )}
                            {/* </Tooltip> */}

                            {/* <Tooltip label="Delete Order"> */}
                            {canDeleteOrder && (
                              <button
                                onClick={() => openDeleteModal(data)}
                                className="flex items-center gap-1 p-1.5 text-sm rounded-full border border-slate-200 bg-white hover:bg-slate-50 hover:text-slate-800 transition shadow-sm"
                              >
                                <img
                                  src="/img/dashboard-icons/trash.svg"
                                  className="size-5"
                                />
                              </button>
                            )}
                            {/* </Tooltip> */}
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
                {/* Sender Profile Card */}
                <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
                  <SectionHeader
                    icon={IconBuildingWarehouse}
                    title={t("Sender Details")}
                  />
                  <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />

                  {/* Rows */}
                  <div className="space-y-3">
                    {/* Company Name row */}
                    <div className="flex items-center justify-between gap-4">
                      <div className="flex items-center gap-2.5 shrink-0">
                        <div className="w-8 h-8 rounded-full bg-indigo-50 flex items-center justify-center border border-indigo-100">
                          <IconBuilding className="w-4 h-4 text-indigo-600" />
                        </div>
                        <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                          <T>Company Name</T>
                        </p>
                      </div>
                      <p className="text-sm font-semibold text-slate-800 text-right truncate">
                        <T>{isOutlet ? data?.outletName || "—" : displayCompanyName || "—"}</T>
                      </p>
                    </div>

                    {/* Account Reference row */}
                    <div className="flex items-center justify-between gap-4">
                      <div className="flex items-center gap-2.5 shrink-0">
                        <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center border border-slate-100">
                          <IconHash className="w-4 h-4 text-slate-400" />
                        </div>
                        <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                          <T>Account Ref No.</T>
                        </p>
                      </div>
                      {isOutlet ? (
                        <span className="inline-block bg-slate-50 border border-slate-200 rounded-lg px-2.5 py-0.5 text-slate-700 font-mono text-[10px] font-semibold">
                          {data?.outletCode || "—"}
                        </span>
                      ) : displayClientId ? (
                        <span className="inline-block bg-slate-50 border border-slate-200 rounded-lg px-2.5 py-0.5 text-slate-700 font-mono text-[10px] font-semibold">
                          {displayClientId}
                        </span>
                      ) : (
                        <p className="text-xs font-semibold text-slate-400">
                          —
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                {/* Receiver Details Card */}

                <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
                  <SectionHeader icon={IconMapPin} title={t("Receiver Details")} />
                  <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
                  {/* Card Header */}

                  {/* Rows */}
                  <div className="space-y-3">
                    {/* Full Name row */}
                    <div className="flex items-center justify-between  gap-4">
                      <div className="flex items-center gap-2.5 shrink-0">
                        <div className="w-8 h-8 rounded-full bg-amber-50 flex items-center justify-center border border-amber-100">
                          <IconUser className="w-4 h-4 text-amber-600" />
                        </div>
                        <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                          <T>Full Name</T>
                        </p>
                      </div>
                      <p className="text-sm font-semibold text-slate-800 text-right truncate">
                        <T>{data?.receiverName || "—"}</T>
                      </p>
                    </div>

                    {/* Mobile row */}
                    <div className="flex items-center justify-between   gap-4">
                      <div className="flex items-center gap-2.5 shrink-0">
                        <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center border border-slate-100">
                          <IconPhone className="w-4 h-4 text-slate-400" />
                        </div>
                        <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                          <T>Mobile</T>
                        </p>
                      </div>
                      <p className="text-sm font-semibold text-slate-700 text-right">
                        {data?.receiverMobile || "—"}
                      </p>
                    </div>

                    {/* Email row */}
                    <div className="flex items-center justify-between gap-4">
                      <div className="flex items-center gap-2.5 shrink-0">
                        <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center border border-slate-100">
                          <IconMail className="w-4 h-4 text-slate-400" />
                        </div>
                        <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                          <T>Email</T>
                        </p>
                      </div>
                      <p className="text-xs font-semibold text-slate-700 text-right break-all max-w-[240px]">
                        {data?.receiverEmail || "—"}
                      </p>
                    </div>

                    {/* Delivery Address row */}
                    <div className="flex items-start justify-between   gap-4">
                      <div className="flex items-center gap-2.5 shrink-0 pt-0.5">
                        <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center border border-slate-100">
                          <IconMapPin className="w-4 h-4 text-slate-400" />
                        </div>
                        <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                          <T>Address</T>
                        </p>
                      </div>
                      <p className="text-xs font-semibold text-slate-700 text-right break-words max-w-[240px] leading-relaxed pt-1">
                        <T>{data?.receiverAddress ? data.receiverAddress.replace(/<[^>]*>/g, "") : "—"}</T>
                      </p>
                    </div>

                    {/* City / Area row */}
                    <div className="flex items-center justify-between gap-4">
                      <div className="flex items-center gap-2.5 shrink-0">
                        <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center border border-slate-100">
                          <IconBuilding className="w-4 h-4 text-slate-400" />
                        </div>
                        <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                          <T>City / Area</T>
                        </p>
                      </div>
                      <p className="text-xs font-semibold text-slate-800 text-right break-words max-w-[240px]">
                        <T>{data?.receiverCityName || data?.receiverCityData || "—"}</T>
                        {data?.receiverDistrictName ||
                          data?.receiverDistrictData ? (
                          <>
                            ,{" "}
                            <T>{data.receiverDistrictName || data.receiverDistrictData}</T>
                          </>
                        ) : (
                          ""
                        )}
                      </p>
                    </div>

                    {/* National Address row */}
                    <div className="flex items-center justify-between gap-4">
                      <div className="flex items-center gap-2.5 shrink-0">
                        <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center border border-slate-100">
                          <IconId className="w-4 h-4 text-slate-400" />
                        </div>
                        <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                          <T>National Address</T>
                        </p>
                      </div>
                      {data?.receiverNationalAddress ? (
                        <span className="inline-block bg-slate-50 border border-slate-200 rounded-lg px-2.5 py-0.5 text-slate-700 text-[10px] font-semibold">
                          {data.receiverNationalAddress}
                        </span>
                      ) : (
                        <p className="text-xs font-semibold text-slate-400">
                          —
                        </p>
                      )}
                    </div>

                    {/* Geo-Coordinates / Google Map row */}
                    <div className="flex items-center justify-between gap-4">
                      <div className="flex items-center gap-2.5 shrink-0">
                        <div className="w-8 h-8 rounded-full bg-amber-50 flex items-center justify-center border border-amber-100">
                          <IconMapPin className="w-4 h-4 text-amber-600" />
                        </div>
                        <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                          <T>Coordinates</T>
                        </p>
                      </div>
                      <div className="flex items-center gap-2">
                        <p className="text-xs font-semibold text-slate-700 font-mono">
                          {data?.receiverLatitude && data?.receiverLongitude
                            ? `${Number(data.receiverLatitude).toFixed(4)}, ${Number(data.receiverLongitude).toFixed(4)}`
                            : "—"}
                        </p>
                        {data?.receiverLatitude && data?.receiverLongitude && (
                          <a
                            href={`https://www.google.com/maps/search/?api=1&query=${data.receiverLatitude},${data.receiverLongitude}`}
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center gap-1 border border-amber-200 text-amber-700 bg-white hover:bg-amber-50 transition text-[10px] font-semibold px-2 py-0.5 rounded-md shadow-sm"
                          >
                            <IconExternalLink
                              size={10}
                              className="text-amber-600"
                            />
                            <T>Open</T>
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Shipping Details Card (Conditional) */}
                {isShipped && (
                  <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
                    <SectionHeader icon={IconTruck} title={t("Shipping Details")} />
                    <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
                    <div className="space-y-2">
                      {/* Forwarded Company row */}
                      <div className="flex items-center justify-between gap-4">
                        <div className="flex items-center gap-2.5 shrink-0">
                          <div className="w-8 h-8 rounded-full bg-cyan-50 flex items-center justify-center border border-cyan-100">
                            <IconBuildingWarehouse className="w-4 h-4 text-cyan-600" />
                          </div>
                          <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                            <T>Forwarded Company</T>
                          </p>
                        </div>
                        <p className="text-sm font-semibold text-slate-800 text-right truncate">
                          <T>{data?.shippingCompany || "—"}</T>
                        </p>
                      </div>

                      {/* Forwarded AWB No row */}
                      <div className="flex items-center justify-between  gap-4">
                        <div className="flex items-center gap-2.5 shrink-0">
                          <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center border border-slate-100">
                            <IconId className="w-4 h-4 text-slate-400" />
                          </div>
                          <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">
                            <T>Forwarded AWB No</T>
                          </p>
                        </div>
                        {data?.shippingAwbNumber ? (
                          <span className="inline-block bg-slate-50 border border-slate-200 rounded-lg px-2.5 py-0.5 text-slate-700 font-mono text-[10px] font-semibold">
                            {data.shippingAwbNumber}
                          </span>
                        ) : (
                          <p className="text-xs font-semibold text-slate-400">
                            —
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {selectedOption === "NewOrder" && showModal && (
        <AddOrdersModal
          onClose={() => setShowModal(false)}
          fetchData={refetch}
        />
      )}
      {selectedOption === "BulkOrder" && showBulkModal && (
        <BulkUploadModals onClose={() => setShowBulkModal(false)} />
      )}
      {selectedOption === "ReverseOrder" && showReverseModal && (
        <ReverseOrderModal onClose={() => setShowReverseModal(false)} />
      )}

      <MessageModal
        open={isReverseOrderWiseOpen}
        onClose={closeReverseOrderWiseModal}
        title={t("Confirmation Required")}
        subtitle={t("Are you sure you want to reverse this order?")}
        img={"/img/inactive.svg"}
        showFooter={true}
        closeButtonText={t("Cancel")}
        actionButtonText={t("Confirm")}
        actionButtonOnClick={handleReverseOrder}
        size="md"
      />
      <MessageModal
        open={isRevertOrder}
        onClose={closeRevertOrder}
        title={t("Confirmation Required")}
        subtitle={t("Are you sure you want to revert this order?")}
        img={"/img/active.svg"}
        showFooter={true}
        closeButtonText={t("Cancel")}
        actionButtonText={t("Confirm")}
        actionButtonOnClick={handleReverseOrder}
        isPending={isReverseOrderPending}
        size="md"
      />

      <NewCommonModal
        classWidth="[@media(min-width:1920px)]:w-8/12 [@media(min-width:1536px)]:w-10/12 "
        title={t("Reverse item")}
        open={openGeneratePickup}
        closeButtonText={t("Cancel")}
        onClose={openGeneratePickupToggleModal}
        actionButtonText={t("Generate")}
        actionButtonOnClick={openGeneratePickupToggleModal}
        isPending={openGeneratePickup}
      >
        <ReverseItemModal
          register={register}
          errors={errors}
          clearErrors={clearErrors}
          setValue={setValue}
          control={control}
          watch={watch}
        />
      </NewCommonModal>

      {/* Global Viewport-Fixed Tooltip to escape scroll-boundary clipping */}
      {hoveredLog && tooltipCoords && (
        <div
          className="fixed flex flex-col items-center min-w-[210px] pointer-events-none transition-all duration-200"
          style={{
            top: tooltipCoords.top - 12,
            left: tooltipCoords.left,
            transform: "translate(-50%, -100%)",
            zIndex: 999999,
          }}
        >
          <div className="bg-[#1e1e1e] text-white text-center rounded-xl py-2 px-3.5 shadow-2xl space-y-1 whitespace-nowrap text-xs border border-neutral-700">
            <p className="font-bold text-white tracking-wide text-[11px]">
              <T>{formatStatusName(hoveredLog.status)}</T>
            </p>
            {(hoveredLog.details || hoveredLog.comment) && (
              <p className="text-[10px] text-slate-300 leading-snug max-w-[190px] whitespace-normal">
                <T>{hoveredLog.details || hoveredLog.comment}</T>
              </p>
            )}
            <p className="text-[10px] text-slate-400 font-mono">
              <T>{formatDate(hoveredLog.createdAt)}</T>,{" "}
              {formatTime(hoveredLog.createdAt)}
            </p>
            {(hoveredLog.userName || hoveredLog.assignedUser) && (
              <div className="flex justify-center pt-0.5">
                <span className="inline-block bg-neutral-800 text-slate-300 text-[9px] font-semibold px-2 py-0.5 rounded border border-neutral-700/60">
                  {hoveredLog.userName ? (
                    <>
                      <T>{hoveredLog.userType || "User"}</T>: {hoveredLog.userName}
                    </>
                  ) : (
                    <>
                      <T>Driver</T>: {hoveredLog.assignedUser}
                    </>
                  )}
                </span>
              </div>
            )}
            {hoveredLog.warehouseName && (
              <div className="flex justify-center pt-0.5">
                <span className="inline-block bg-neutral-800 text-slate-400 text-[9px] px-2 py-0.5 rounded border border-neutral-700/50">
                  📦 <T>{hoveredLog.warehouseName}</T>
                </span>
              </div>
            )}
          </div>
          <div className="w-2.5 h-2.5 bg-[#1e1e1e] border-r border-b border-neutral-700 rotate-45 -mt-1.5" />
        </div>
      )}
    </>
  );
}
